import { useExportEvents } from '../../hooks/useExports';
import { useCollectionEvents } from '../../hooks/useCollections';
import { useSearchTermJobEvents } from '../../hooks/useSearchTerms';
import { useTaggingEvents } from '../../hooks/useProjectTags';
import { useReportEvents } from '../../hooks/useReports';
import { useBatchingEvents } from '../../hooks/useProjectBatches';
import { useAuditLogEvents } from '../../hooks/useAuditLog';
import { useResourceEvents } from '../../hooks/useResource';
import { useBillingEvents } from '../../hooks/useBilling';

/**
 * Renders nothing. Mounted once for the lifetime of the app (see the
 * <react-websocket-bridge> element in app/index.html) to own every websocket listener whose
 * effect is app-wide: header task-dropdown progress, completion toasts, and cache
 * invalidation for jobs that outlive the page they were started from.
 *
 * Why this exists: the Angular services these listeners replaced were singletons, so they
 * kept relaying from anywhere. A listener mounted on a tab stops the moment the user
 * navigates — an export started on the Exports tab would stop updating the dropdown as soon
 * as they opened Browse, and bulk tagging is started from the review grid, nowhere near the
 * Tags tab. None of these hooks take a projectId: each derives it from the message, so a job
 * finishing in a project the user has navigated away from still lands correctly.
 *
 * Tabs keep their own listeners only for things that are genuinely local to being on screen.
 *
 * When the header becomes React (Wave 5), the task list moves out of the Angular iioProgress
 * directive and into a store this component writes to; taskProgress.ts is the seam.
 */
export function WebSocketBridge() {
  useExportEvents();
  useCollectionEvents();
  useSearchTermJobEvents();
  useTaggingEvents();
  useReportEvents();
  useBatchingEvents();
  useAuditLogEvents();
  useResourceEvents();
  useBillingEvents();

  return null;
}
